



























































































































































































































































import Vue from "vue";
import Page from "@/components/Page.vue";

// import Istore, {InterfaceStore} from "../services/InterfaceStore";
import NavigationButton from "@/components/NavigationButton.vue";
import ButtonCheckBox from "@/components/ButtonCheckBox.vue";
import CheckBox from "@/components/CheckBox.vue";
import DateTimeInput from "../../../components/DateTimeInput.vue";
import DateInput from "../../../components/DateInput.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";


// import store, { CashFlowStore } from "@/modules/cashFlowRiport/services/CashFlowStore";
import eventBus from "@/services/eventBus";
import GlobalStore from "@/models/GlobalStore";
import IconButton from "@/components/IconButton.vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import CarRequestTool from "./requestTools/CarRequestTool.vue";
import PartnerRequestTool from "./requestTools/PartnerRequestTool.vue";
import InvoiceRequestTool from "./requestTools/InvoiceRequestTool.vue";
import store, { InterfaceStore } from "../services/InterfaceStore";
import { IfaceType } from "../models/IfaceType";
import { IfaceFeature } from "../models/IfaceSyncFeature";
import { Confirmation } from "@/components/ConfirmationBox.vue";




enum ConfirmType {
  None = 0,
  ReSyncSelectedItems = 1,
  ReSyncInterface = 2,
  MarkSelectedItemsSkipped = 3,
  SetRemarkOnSelectedItems = 4,
}

interface Data {
  store: InterfaceStore;
  showRemarkField: boolean;
  showConfirm: boolean;
  confirmType: number;
  remarkText: string;
  IfaceType: typeof IfaceType;
  IfaceFeature: typeof IfaceFeature;

}

interface Methods {
  reload(): void;
  /** Ugrás a rendszerparaméterek Külső interfészek kártyájára. */
  openInterfaceParameters(): void;
  handleShowRequestTool(): void;
  handleShowConfirm(type: ConfirmType): void;
  sendRequest(): Promise<void>;
  featureTooltip(tooltip: string, feature: IfaceFeature): string;
}

interface Computed {
  /** A toolbar dátum-intervallum jelentése az aktuális interfész típuson. */
  dateFilterTooltip: string;
}

interface Props {
  /** Előzmény mód — ilyenkor csak a szűrők jelennek meg, szinkron funkció gombok nem. */
  historyMode: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    historyMode: { type: Boolean, default: false },
  },

  components: {
    NavigationButton,
    // ButtonCheckBox,
    CheckBox,
    // DateInput,
    // DateTimeInput,
    DateInput,
    // IconButton
    CarRequestTool,
    PartnerRequestTool,
    InvoiceRequestTool,
  },

  data() {
    return {
      store,
      showRemarkField: false,
      showConfirm: false,
      confirmType: 0,
      remarkText: "",
      ConfirmType,
      IfaceType,
      IfaceFeature,

    };
  },

  async beforeMount() {
    this.store.loadSyncStatuses();
    await this.store.loadInterfaces();
    await this.store.loadFeatures();
    await this.store.loadInterfaceTypes();
  },

  watch: {
    /** Interfész váltáskor a hozzá tartozó feature sorok (láthatóság + funkciók) újratöltése */
    "store.selectedInterface": {
      async handler() {
        await this.store.loadInterfaceTypes();
      },
    },
  },

  computed: {
    dateFilterTooltip() {
      const isInvoice = this.store.selectedInterfaceType === IfaceType.InInvoice
        || this.store.selectedInterfaceType === IfaceType.OutInvoice;
      return isInvoice
        ? "Számla kiállítás dátuma (lista szűrés és szinkron intervallum)"
        : "Utolsó szinkron dátuma (lista szűrés) / szinkron intervallum";
    },
  },

  methods: {
    /** Mindkét apisearch újratöltése. */
    reload() {
      eventBus.$emit("refreshSyncList");
      eventBus.$emit("refreshSyncErrorList");
    },

    /** A rendszerparaméterek oldal a query alapján a Külső interfészek kártyára görget. */
    openInterfaceParameters() {
      this.$router.push({ path: "/parameters", query: { section: "iface-sync" } });
    },

    handleShowRequestTool() {
      this.store.showRequestTool = !this.store.showRequestTool;
    },

    /** A gomb tooltipje — tiltott funkciónál jelezzük, hogy itt nem elérhető. */
    featureTooltip(tooltip, feature) {
      return this.store.hasFeature(feature)
        ? tooltip
        : "Ezen az interfészen és típuson ez a funkció nem elérhető";
    },

    handleShowConfirm(type) {
      this.confirmType = type;
      this.showConfirm = !this.showConfirm;
    },

    /**
     * A megerősítés gomb action handlere — a `confirmType` alapján dönti el a műveletet.
     *  - ReSyncSelectedItems: a két apisearch `selected===true` sorainak id-jait küldi a backendre
     *    az aktuális `selectedInterfaceType`-pal.
     *  - ReSyncInterface: a toolbar `fromDate`/`toDate` dátumait küldi a backendre
     *    az aktuális `selectedInterfaceType`-pal.
     *  - MarkSelectedItemsSkipped: a kijelölt sorokból új köztes tábla sort hoz létre a backend,
     *    `UserModified=true`-val és Skip (5) státusszal. Számlánál fej + tételek is másolódnak.
     *    Nincs külső API hívás.
     *  - SetRemarkOnSelectedItems: a kijelölt sorok `sync_remark` mezőjét írja felül a megadott
     *    szöveggel — új sor nem keletkezik, külső API hívás nincs.
     */
    async sendRequest() {
      const confirmTypesNeedSelection = [
        ConfirmType.ReSyncSelectedItems,
        ConfirmType.MarkSelectedItemsSkipped,
        ConfirmType.SetRemarkOnSelectedItems,
      ];

      if (confirmTypesNeedSelection.includes(this.confirmType) && this.store.selectedItems.length === 0) {
        eventBus.$emit("error", "Nincs kijelölt tétel a művelethez.");
        this.handleShowConfirm(ConfirmType.None);
        return;
      }

      try {
        if (this.confirmType === ConfirmType.ReSyncSelectedItems) {
          await this.store.downSyncSelectedItems();
        } else if (this.confirmType === ConfirmType.ReSyncInterface) {
          await this.store.downSyncInterface();
        } else if (this.confirmType === ConfirmType.MarkSelectedItemsSkipped) {
          await this.store.markSelectedItemsSkipped();
        } else if (this.confirmType === ConfirmType.SetRemarkOnSelectedItems) {
          await this.store.setSyncRemarkOnSelectedItems(this.remarkText);
          this.showRemarkField = false;
          this.remarkText = "";
        } else {
          return;
        }

        this.reload();
      } catch (e) {
        console.error(e);
      } finally {
        this.handleShowConfirm(ConfirmType.None);
      }
    },
  },
});
